import { render, staticRenderFns } from "./AttributesPopup.vue?vue&type=template&id=44646dd5"
import script from "./AttributesPopup.vue?vue&type=script&lang=js"
export * from "./AttributesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports